import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_CUSTOM_FORMAT } from './schema';

const MUTATION = gql`
  mutation UpdateCustomFormat(
    $id: ID!
    $name: String!
    $instructions: String!
    $defaultForGenerationTools: [GenerationToolEnum!]
  ) {
    updateCustomFormat(
      id: $id
      name: $name
      instructions: $instructions
      defaultForGenerationTools: $defaultForGenerationTools
    ) {
      ...CustomFormat
    }
  }
  ${FRAGMENT_CUSTOM_FORMAT}
`;

export const updateCustomFormat = async ({ id, name, instructions, defaultForGenerationTools }) => {
  const variables = {
    id,
    name,
    instructions,
    defaultForGenerationTools,
  };

  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });
  return getSingleProp(result.data);
};
